import { APIModel, APIModelImpl, APIModelHandler } from '../../../../toolkit/uicomponentapimodel';
import { BlacklistDto } from 'src/com/sixdee/crbtportal/core/dto/blacklist/blacklistdto';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { AddToBlacklistDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/addtoblacklist/addtoblacklistdto';
import { BlacklistMemberDetailsDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/addtoblacklist/blacklistmemberdetailsdto';
import { AddToBlacklistResponse } from 'src/com/sixdee/crbtportal/core/api/blacklist/addtoblacklist/addtoblacklistresponse';
import { AddToBlacklistRequestImpl } from 'src/com/sixdee/crbtportal/core/api/blacklist/addtoblacklist/addtoblacklistrequest';
import { MemberDetailsDto } from 'src/com/sixdee/crbtportal/core/dto/listtones/memberdetailsdto';


export interface ManageBlacklistAPIModel extends APIModel
{
    onCreateBlacklist(groupDto: BlacklistDto): void;
}

export class ManageBlacklistAPIModelImpl extends APIModelImpl implements ManageBlacklistAPIModel
{
    constructor(applicationContext: BaseContext, apiModelHandler: APIModelHandler)
    {
        super(applicationContext, apiModelHandler);
    }

    onCreateBlacklist(groupDto: BlacklistDto): void
    {
        // console.log("onCreateBlacklist() invoked");

        let addToBlacklistDto = new AddToBlacklistDtoImpl();
        addToBlacklistDto.setLanguage(this.getContext().getUserContext().getLanguage());
        addToBlacklistDto.setAPartyMsisdn(this.getContext().getUserContext().getMsisdn());
        addToBlacklistDto.setChannelId(this.getContext().getUserContext().getChannelId());

        let membersDetailsDto;

        let membersList = groupDto.getMembersList().map((detailsDto: MemberDetailsDto) =>
        {
            membersDetailsDto = new BlacklistMemberDetailsDtoImpl();
            membersDetailsDto.setBPartyName(detailsDto.getMemberName());
            membersDetailsDto.setBPartyMsisdn(detailsDto.getMsisdn());

            return membersDetailsDto;
        });

        addToBlacklistDto.setMemberDetails(membersList);

        this.getAPIProcesssorFactory().getBlacklistProcessorFactory()
        .getAddToBlacklistAPIProcessor()
        .success((addToBlacklistResponse: AddToBlacklistResponse)=>
        {
            console.log("success() invoked ##########ADD BLACKLIST###############");

            this.getAPIModelHandler().onSuccess(addToBlacklistResponse.getAPIFeature(), 
            addToBlacklistResponse.getDescription(), addToBlacklistResponse);
         })
        .failure((addToBlacklistResponse: AddToBlacklistResponse)=>
         {
           this.getAPIModelHandler().onFailure(addToBlacklistResponse.getAPIFeature(), 
           addToBlacklistResponse.getDescription(), undefined);
         })
        .execute(new AddToBlacklistRequestImpl(addToBlacklistDto));
    }
}


 


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/blacklist/manageblacklist/manageblacklistapimodel.ts